<div class="sidebar-overlay" [ngClass]="{ visible: isVisible }" (click)="onClose()"></div>
<div class="journal-sidebar" [ngClass]="{ visible: isVisible }">
  <!-- Header -->
  <div class="panel-header">
    <div class="panel-title">Notes</div>
    <div class="close-button" (click)="onClose()">
      <img src="assets/img/x.svg" style="width: 24px; height: 24px" alt="close" />
    </div>
  </div>

  <!-- Filter -->
  <div class="filter-section" [class.has-clear]="isFilterChanged">
    <div class="filter-dropdown-wrapper">
      <div class="filter-input" [class.has-filters]="selectedTypes.length > 0" (click)="toggleFilterDropdown()">
        <div class="filter-content">
          <div class="filter-text">{{ getFilterText() }}</div>
          <div class="filter-icon">
            <img
              src="assets/img/chevron-down.svg"
              class="chevron-down"
              [ngClass]="{ rotated: showFilterDropdown }"
              alt="chevron down" />
          </div>
        </div>
      </div>

      <!-- Filter Dropdown -->
      <div
        class="filter-dropdown"
        [class.has-filters]="selectedTypes.length > 0"
        *ngIf="showFilterDropdown"
        (click)="$event.stopPropagation()">
        <div class="dropdown-option" *ngFor="let type of noteTypes" (click)="toggleNoteType(type.type)">
          <input
            type="checkbox"
            class="flag-checkbox"
            [checked]="selectedTypes.includes(type.type)"
            (click)="$event.stopPropagation(); toggleNoteType(type.type)" />
          <div class="option-text">{{ type.label }}</div>
        </div>
      </div>
    </div>

    <span class="clear-btn" *ngIf="isFilterChanged" (click)="clearFilter()">Clear</span>
  </div>

  <!-- Content Area -->
  <div class="panel-content">
    <!-- Loading -->
    <div class="loading-state" *ngIf="isLoading">
      <div class="loading-spinner"></div>
    </div>

    <!-- Notes List -->
    <ng-container *ngIf="!isLoading && filteredNotes.length > 0">
      <div class="note-card" *ngFor="let note of filteredNotes">
        <!-- Note Header -->
        <div class="note-header">
          <div class="note-author">
            <div class="author-name">{{ getUserDisplayName(note.user) }}</div>
          </div>
          <div class="note-type-badge" *ngIf="note.type">
            <div class="badge-text">{{ getNoteTypeLabel(note.type) }}</div>
          </div>
        </div>

        <!-- Divider -->
        <div class="note-divider"></div>

        <!-- Note Metadata -->
        <div class="note-metadata">
          <div class="metadata-item">
            <img src="assets/img/calendar.svg" class="metadata-icon" alt="calendar" />
            <div class="metadata-text">{{ formatDate(note.date) }}</div>
          </div>
          <div class="metadata-item">
            <img src="assets/img/time.svg" class="metadata-icon" alt="time" />
            <div class="metadata-text">{{ formatTime(note.date) }}</div>
          </div>
          <div class="metadata-item">
            <img src="assets/img/appointment.svg" class="metadata-icon" alt="appointment" />
            <div class="metadata-text">
              {{ getTruncatedMetadataText(note.type === 'scheduling' ? note.reason : note.type) }}
            </div>
          </div>
        </div>

        <!-- Note Content -->
        <div class="note-content">
          {{ (isExpanded(note) ? note.note : getTruncatedText(note.note)) | stripHtml }}
        </div>

        <!-- Note Footer -->
        <div class="note-footer">
          <div class="note-tag">
            <img
              [src]="getTagIconSrc(getNoteTypeValue(note.user))"
              class="tag-icon"
              [ngClass]="getTagIconClass(getNoteTypeValue(note.user))"
              [alt]="getNoteTypeLabel(note.type)" />
            <div class="tag-text" [ngClass]="getTagTextClass(getNoteTypeValue(note.user))">
              {{ getTagText(getNoteTypeValue(note.user)) }}
            </div>
          </div>
          <div class="action-icons" *ngIf="canEditNote(note)">
            <div class="action-icon" (click)="openEditModal(note)" title="Edit">
              <img src="assets/img/svg/edit-pencil.svg" width="24" height="24" alt="Edit" />
            </div>
            <div class="action-icon" (click)="deleteNote(note)" title="Delete">
              <img src="assets/img/svg/trash-delete.svg" width="24" height="24" alt="Delete" />
            </div>
          </div>
          <div class="read-more-button" *ngIf="shouldShowReadMore(note.note)" (click)="toggleNoteExpansion(note)">
            <div class="button-text">{{ isExpanded(note) ? 'Read Less' : 'Read More' }}</div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Empty State (journal default or no filters) -->
    <div class="empty-state" *ngIf="!isLoading && filteredNotes.length === 0 && !isFilterChanged">
      <div class="empty-state-container">
        <div class="empty-state-title">No journal entries yet</div>
        <div class="empty-state-subtitle">
          Start documenting underwriting decisions, rationale, and recommended actions for this inspection.
        </div>
      </div>
    </div>

    <!-- Empty State (filtered with non-default selection) -->
    <div class="empty-state" *ngIf="!isLoading && filteredNotes.length === 0 && isFilterChanged">
      <div class="empty-state-container">
        <div class="empty-state-title">No results found</div>
        <div class="empty-state-subtitle">Try adjusting your filters or search terms.</div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="panel-footer">
    <button class="add-entry-btn" (click)="openAddModal()">
      <span>Add Journal Entry</span>
      <img src="assets/img/svg/plus-add.svg" width="16" height="16" alt="Add" />
    </button>
  </div>
</div>

<!-- Add / Edit Journal Entry Modal -->
<app-add-journal-entry-modal
  *ngIf="showAddModal"
  [inspectionId]="inspectionId"
  [editNote]="editingNote"
  (closeModal)="closeAddModal()"
  (entryCreated)="onEntryCreated($event)"
  (entryUpdated)="onEntryUpdated($event)">
</app-add-journal-entry-modal>
